import { uniq } from './lodash';
export const differingKeys = (obj1, obj2) => {
    if (!obj1 || !obj2)
        return [];
    return uniq(Object.keys(obj1)
        .concat(Object.keys(obj2))
        .filter((key) => obj1[key] !== obj2[key]));
};
